const NOTIF_DATE_FMT = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
export function formatNotifDate (iso) {
  return iso ? NOTIF_DATE_FMT.format(new Date(iso)) : '—';
}

// CT1 D5 — the reference's tone by importance (LeadCard.dc.html:125-133), derived from `type`:
// there is NO `severity` field (0 app-wide, not among the 30 payload keys); neutral is the
// default. D6 — emitted on both hosts, painted only under `.outcrm-scope` (never the bell).
const NOTIF_TONE = {
  period_end_underperform: 'danger',
  activity_gap: 'warn', collab_ending_tomorrow: 'warn', collab_ended_today: 'warn',
  reminder: 'warn', test_end_reminder: 'warn',
};
const notifTone = (type) => NOTIF_TONE[type] || 'neutral';

export function LeadNotificationsList ({ notifications = [], loading = false, onNotificationClick }) {
  return (
    <div className='details-modal__log-list'>
      {loading ? (
        <div className='empty-state empty-state--compact'><p>Загружаем…</p></div>
      ) : notifications.length === 0 ? (
        <div className='empty-state empty-state--compact'><p>Уведомлений нет</p></div>
      ) : (
        notifications.map(n => (
          <div
            key={n.id}
            className={`activity activity--compact${!n.readAt ? ' activity--unread' : ''} oc-lead-card__notif oc-lead-card__notif--${notifTone(n.type)}`}
            {...(onNotificationClick
              ? { onClick: () => onNotificationClick(n), role: 'button', tabIndex: 0, style: { cursor: 'pointer' },
                  onKeyDown: (e) => { if (e.key === 'Enter') onNotificationClick(n); } }
              : {})}
          >
            <div className='activity__meta'>
              <span className='activity__author'>{n.title}</span>
              <span className='activity__time'>{formatNotifDate(n.createdAt)}</span>
            </div>
            <div className='activity__body'>
              <div className='activity__note'>{n.body}</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}
